import { apiRequest } from "./api";

export interface BonusPayoutPeriod {
  /** 1–12 */
  month: number;
  /** H1 = 1st–15th, H2 = 16th–EOM */
  half: "H1" | "H2";
}

export interface BonusConfig {
  bonusId: string;
  businessId: string;
  name: string;
  payoutPeriods: BonusPayoutPeriod[];
  basisMonths: number;
  enabled: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface SuggestedBonus {
  bonusConfigId: string;
  label: string;
  amount: number;
  isProrated: boolean;
  prorationPct?: number;
}

export interface CreateBonusConfigPayload {
  name: string;
  payoutPeriods: BonusPayoutPeriod[];
  basisMonths: number;
  enabled: boolean;
}

export interface UpdateBonusConfigPayload {
  name?: string;
  payoutPeriods?: BonusPayoutPeriod[];
  basisMonths?: number;
  enabled?: boolean;
}

export const bonusConfigApi = {
  list: (businessId: string) =>
    apiRequest<{ items: BonusConfig[] }>(`/biz/${businessId}/bonus-configs`),

  create: (businessId: string, payload: CreateBonusConfigPayload) =>
    apiRequest<{ config: BonusConfig }>(`/biz/${businessId}/bonus-configs`, {
      method: "POST",
      body: payload,
    }),

  update: (businessId: string, bonusId: string, payload: UpdateBonusConfigPayload) =>
    apiRequest<{ updated: boolean }>(`/biz/${businessId}/bonus-configs/${bonusId}`, {
      method: "PATCH",
      body: payload,
    }),

  delete: (businessId: string, bonusId: string) =>
    apiRequest<{ deleted: boolean }>(`/biz/${businessId}/bonus-configs/${bonusId}`, {
      method: "DELETE",
    }),
};
